import React, { useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Row, CardHeader, Button } from 'reactstrap';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { columnsClient } from '../Route/table-city';
import { useHistory } from 'react-router-dom';
import { handleSendGeneric } from 'services/generic';
import { useEffect } from 'react';
import { ModalDebtor } from './modal-debtor';
import { ModalVisitRecord } from './modal-visit-record';

const OptionsClient = ({ data, history, setChangeColor, changeColor }) => {
  return (
    <tr
      style={{
        color: changeColor?.color ? changeColor?.color : '',
        background: changeColor?.background ? changeColor?.background : '',
      }}
    >
      <td>
        <Button
          color='warning'
          onClick={() => history.push('/admin/sale/pre-sale/new', data)}
          size='lg'
          style={{ whiteSpace: 'nowrap' }}
          block
        >
          Pré Venda
        </Button>
      </td>
      <td>
        <Button
          color='success'
          onClick={() => history.push('/admin/sale/execute-sale', data)}
          size='lg'
          style={{ whiteSpace: 'nowrap' }}
          block
        >
          Venda
        </Button>
      </td>
      <td>
        <ModalDebtor data={data} />
      </td>
      <td>
        <ModalVisitRecord data={data} setChangeColor={setChangeColor} />
      </td>
    </tr>
  );
};

const RowCustom = ({ provider, row, index, history }) => {
  const [open, setOpen] = useState(false);
  const [changeColor, setChangeColor] = useState({
    background: '',
    color: '',
  });

  useEffect(() => {
    async function findVisitRegister() {
      handleSendGeneric(
        '/v1/visit-record/filter-all/CLIENT/' + row.original.id,
        'GET'
      );

      const clientRaw = await handleSendGeneric(
        '/v1/client/' + row.original.id,
        'GET'
      );

      if (clientRaw.stateClientEnum === 'VISITED') {
        setChangeColor({
          background: 'green',
          color: 'white',
        });
      } else if (clientRaw.stateClientEnum === 'COME_BACK_LATER') {
        setChangeColor({
          background: 'yellow',
          color: 'black',
        });
      }
    }

    findVisitRegister();
  }, [row.original]);

  const updateStateOpen = (e) => {
    e.preventDefault();
    setOpen(!open);
  };

  return !open ? (
    <tr
      key={index}
      {...row.getRowProps()}
      {...provider.draggableProps}
      style={{
        ...provider.draggableProps.style,
        ...changeColor,
      }}
      ref={provider.innerRef}
      onClick={updateStateOpen}
    >
      <td {...provider.dragHandleProps}> = </td>
      {row.cells.map((cell) => {
        return (
          <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
            {cell.render('Cell')}
          </td>
        );
      })}
    </tr>
  ) : (
    <>
      <tr
        key={index}
        {...row.getRowProps()}
        {...provider.draggableProps}
        style={{
          ...provider.draggableProps.style,
          ...changeColor,
        }}
        ref={provider.innerRef}
        onClick={updateStateOpen}
      >
        <td {...provider.dragHandleProps}> = </td>
        {row.cells.map((cell) => {
          return (
            <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
              {cell.render('Cell')}
            </td>
          );
        })}
      </tr>
      <OptionsClient
        data={row.original}
        history={history}
        setChangeColor={setChangeColor}
        changeColor={changeColor}
      />
    </>
  );
};

export function TableGenericWithDragAndDrop({
  columns,
  data,
  setData,
  history,
  city,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  const handleSavePosition = (dataView) => {
    handleSendGeneric(
      '/v1/data-view?type=ROUTE_CITY_CLIENT&action=UPDATE&idFather=' + city.id,
      'POST',
      dataView
    );
  };

  const handleDragEnd = async (e) => {
    const { source, destination } = e;
    if (!destination || source.index === destination.index) return;
    let dataRaw = [];

    setData((prevData) => {
      const tempData = [...prevData];
      const [removed] = tempData.splice(source.index, 1);
      tempData.splice(destination.index, 0, removed);
      dataRaw = [...tempData];
      return tempData;
    });

    await handleSavePosition(dataRaw);
  };

  return (
    <>
      <GlobalFilter
        disableButtomCreate={true}
        filter={globalFilter}
        setFilter={setGlobalFilter}
      />
      <DragDropContext onDragEnd={handleDragEnd}>
        <Table responsive {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                <th />
                {headerGroup.headers.map((column) => (
                  <th
                    scope='col'
                    {...column.getHeaderProps()}
                    style={{ fontSize: '18px' }}
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <Droppable droppableId='droppable-1'>
            {(provider) => (
              <tbody
                {...getTableBodyProps()}
                ref={provider.innerRef}
                {...provider.droppableProps}
              >
                {rows.length !== 0 ? (
                  rows.map((row, index) => {
                    prepareRow(row);
                    return (
                      <Draggable
                        key={row?.original?.name}
                        draggableId={row?.original?.name}
                        index={index}
                      >
                        {(provider) => (
                          <RowCustom
                            provider={provider}
                            row={row}
                            index={index}
                            history={history}
                          />
                        )}
                      </Draggable>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan='7'
                      style={{
                        textAlign: 'center',
                        width: '20px',
                        fontSize: '18px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '14px',
                          alignItems: 'center',
                        }}
                      >
                        Não há registros disponíveis, por gentileza vincule um
                        cliente a esta cidade!
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
    </>
  );
}

export const ClientSale = ({ data, city }) => {
  let history = useHistory();
  const [cities, setCities] = useState([]);

  const columns = useMemo(() => [...columnsClient], []);

  useEffect(() => {
    async function getData() {
      handleSendGeneric(
        '/v1/data-view?type=ROUTE_CITY_CLIENT&idFather=' + city.id,
        'POST',
        data
      ).then((response) => {
        setCities(() => {
          return response.data[0];
        });
      });
    }

    getData();
  }, [city, data]);

  const handleSavePosition = () => {
    handleSendGeneric(
      '/v1/data-view?type=ROUTE_CITY_CLIENT&idFather=' + city.id,
      'POST',
      cities
    ).then((response) => {
      setCities(() => {
        return response.data[0];
      });
    });
  };

  return (
    <>
      <Card className='shadow'>
        <CardHeader className='border-0'>
          <Row className='align-items-center'>
            <div
              style={{ display: 'flex', justifyContent: 'space-between' }}
              className='col'
            >
              <h3 className='mb-0'>Clientes para atendimento</h3>
              <Button
                color='success'
                onClick={() => handleSavePosition()}
                size='md'
              >
                Ordernar
              </Button>
            </div>
          </Row>
        </CardHeader>
        <TableGenericWithDragAndDrop
          columns={columns}
          data={cities}
          setData={setCities}
          history={history}
          city={city}
        />
      </Card>
    </>
  );
};
